import { compose } from 'redux'
import { connect } from 'react-redux'
import withType from 'components/common/hoc/withType'
import BOTMyAppointmentsDetailsMyGarage from './BOTMyAppointmentsDetailsMyGarage'
import { lifecycle, withProps, withStateHandlers } from 'recompose'
import {
  getFirstNextAppointmentAndVehicle,
  generateUpcomingAppointmentsWithMilliseconds,
  isVehicleSelected,
  getAllNextAppointments,
  sortAppointmentInChronologicalOrder
} from '../../helpers'
import withRequestApptClick from 'components/common/hoc/withRequestApptClick'
import isMyGaragePage from 'helpers/isMyGaragePage'
import isVehicleDetailsPage from 'helpers/isVehicleDetailsPage'
import { getLocationPathname } from 'selectors/getPageLocation'
import { getCurrentStoreIsE2EAppointment } from 'selectors/getCurrentStore'
import { SCHEDULE_APPOINTMENT, REQUEST_APPOINTMENT } from 'constant'

const mapStateToProps = (state) => {
  const hasActiveVehicle = isVehicleSelected(state)

  return {
    hasActiveVehicle,
    isMyGaragePage: isMyGaragePage(getLocationPathname(state)),
    isVehicleDetailsPage: isVehicleDetailsPage(getLocationPathname(state)),
    isE2EAppointment: getCurrentStoreIsE2EAppointment(state)
  }
}

const withAppointmentsProps = withProps(({ appointments, isMyGaragePage, isE2EAppointment }) => {
  const futureAppointments = generateUpcomingAppointmentsWithMilliseconds(appointments)
  const { nextAppointmentVehicle, nextAppointment } = getFirstNextAppointmentAndVehicle(futureAppointments)
  const nextAppointments = getAllNextAppointments(appointments)

  return {
    nextAppointmentVehicle: isMyGaragePage
      ? nextAppointmentVehicle
      : ((appointments && appointments.length && appointments[0].vehicle) || {}),
    userHasAppointments: isMyGaragePage
      ? Boolean(nextAppointment)
      : Boolean(nextAppointments),
    nextAppointment, // for the My Garage page, we are getting the first nearest future appointment
    nextAppointments: nextAppointments // for the Vehicle details page we are getting all future appointments
      ? sortAppointmentInChronologicalOrder(nextAppointments)
      : nextAppointments,
    appointmentButtonLabel: isE2EAppointment ? SCHEDULE_APPOINTMENT : REQUEST_APPOINTMENT
  }
})

const withMessageStateHandlers = withStateHandlers(
  ({ hasActiveVehicle }) => ({
    isInfoMessageVisible: hasActiveVehicle
  }), {
    setIsInfoMessageVisible: () => (isInfoMessageVisible) => ({
      isInfoMessageVisible
    })
  })

const withMyAppointmentsLifecycle = lifecycle({
  componentDidUpdate({ hasActiveVehicle: prevHasActiveVehicle }) {
    const {
      hasActiveVehicle,
      setIsInfoMessageVisible
    } = this.props

    if (prevHasActiveVehicle !== hasActiveVehicle) {
      setIsInfoMessageVisible(hasActiveVehicle)
    }
  }
})

export default compose(
  withType({ type: ['BOTMyAppointmentsDetailsMyGarage', 'BOTMyVehicleAppointmentsDetails']}),
  connect(mapStateToProps),
  withAppointmentsProps,
  withMessageStateHandlers,
  withMyAppointmentsLifecycle,
  withProps(() => ({ navigateToQuickApptPage: true })),
  withRequestApptClick
)(BOTMyAppointmentsDetailsMyGarage)
